export const getAttributeDefinitions = (variant: GQL.IProductVariant | GQL.IOrderItem, attributes: Array<GQL.IAttribute>, language: string) => {
  if (!attributes || !Array.isArray(attributes) || !variant) {
    return undefined;
  }

  const { definition } = variant;
  if (!definition) {
    return undefined;
  }

  // projde nastavení varianty
  const output = Object.keys(definition).map((definitionAttributeId: any) => {
    // definice
    const variantDefinition = {
      title: undefined,
      values: [] as string[],
    };

    const attribute = attributes.find((attr: GQL.IAttribute) => attr.id === definitionAttributeId);
    if (attribute) {
      variantDefinition.title = attribute.name[language] || attribute.title;
      const definitionValues = definition[definitionAttributeId];
      // více hodnot v poli
      if (Array.isArray(definitionValues)) {
        definitionValues.forEach((v: string) => {
          const attributeValue = attribute.values && attribute.values.find((av: GQL.IAttributeValue) => av.id === v);
          if (attributeValue) {
            variantDefinition.values.push(attributeValue.value[language]);
          }
        });
      } else if (typeof definitionValues === 'string') {
        const attributeValue = attribute.values && attribute.values.find((av: GQL.IAttributeValue) => av.id === definitionValues);
        if (attributeValue) {
          variantDefinition.values.push(attributeValue.value[language]);
        }
      }
    }

    // byl nalezen attribut i hodnoty
    if (variantDefinition.title && variantDefinition.values.length > 0) {
      return variantDefinition;
    }

    return null;
  });

  return output.filter(o => !!o);
};

export const displayAttributeDefinitions = (definitions: any[]) => {
  if (definitions) {
    return definitions.map(d => {
      return d.title + `: ` + d.values.join(', ');
    }).join(', ');
  }

  return undefined;
};


// WEBPACK FOOTER //
// ./src/helpers/products/getAttributeDefinitions.ts